import type { AssessmentQuestion } from '@entities/assessment'

import imgQuestion3 from '../../../../ui/images/questions/math/grade-k4/question-3.png'
import imgQuestion6 from '../../../../ui/images/questions/math/grade-k4/question-6.png'
import imgQuestion11 from '../../../../ui/images/questions/math/grade-k4/question-11.png'
import imgQuestion12 from '../../../../ui/images/questions/math/grade-k4/question-12.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k4_1',
    title: 'Which expanded form builds the number 45378?',
    topic: 'Place Value',
    answers: [
      {
        name: 'grade_k4_1_a',
        text: '4 × 10000 + 1000 + 3 × 100 + 7 × 10 + 8',
      },
      {
        name: 'grade_k4_1_b',
        text: '4 × 10000 + 5 × 1000 + 7 × 10 + 8',
      },
      {
        name: 'grade_k4_1_c',
        text: '4 × 10000 + 5 × 1000 + 3 × 100 + 7 × 10 + 8',
        correct: true,
      },
      {
        name: 'grade_k4_1_d',
        text: '4 × 10000 + 5 × 1000 + 3 × 100 + 8',
      },
    ],
  },
  {
    name: 'grade_k4_2',
    title: 'Which number is rounded off to 23000?',
    topic: 'Rounding Off',
    answers: [
      {
        name: 'grade_k4_2_a',
        text: '22,586',
        correct: true,
      },
      {
        name: 'grade_k4_2_b',
        text: '21,500',
      },
      {
        name: 'grade_k4_2_c',
        text: '22,250',
      },
      {
        name: 'grade_k4_2_d',
        text: '22,430',
      },
    ],
  },
  {
    name: 'grade_k4_3',
    title: 'The sum of 8324 and 6128 is:',
    topic: 'Algorithm for Addition',
    image: imgQuestion3,
    answers: [
      {
        name: 'grade_k4_3_a',
        text: '14452',
        correct: true,
      },
      {
        name: 'grade_k4_3_b',
        text: '14450',
      },
      {
        name: 'grade_k4_3_c',
        text: '14480',
      },
      {
        name: 'grade_k4_3_d',
        text: '1582',
      },
    ],
  },
  {
    name: 'grade_k4_4',
    title: 'The product of 589 by 63 is:',
    topic: 'Multi-digit Multiplication',
    answers: [
      {
        name: 'grade_k4_4_a',
        text: '36,107',
      },
      {
        name: 'grade_k4_4_b',
        text: '37,107',
        correct: true,
      },
      {
        name: 'grade_k4_4_c',
        text: '35,107',
      },
      {
        name: 'grade_k4_4_d',
        text: '34,107',
      },
    ],
  },
  {
    name: 'grade_k4_5',
    title: 'If 4225 is divided by 5, the quotient will be:',
    topic: 'Multi-digit Division',
    answers: [
      {
        name: 'grade_k4_5_a',
        text: '745',
      },
      {
        name: 'grade_k4_5_b',
        text: '645',
      },
      {
        name: 'grade_k4_5_c',
        text: '545',
      },
      {
        name: 'grade_k4_5_d',
        text: '845',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_6',
    title: 'Sara learns guitar for 1/2 hours daily. Find out the correct fraction equivalent to Sara’s lessons after 8 days.',
    topic: 'Fraction Equivalence',
    image: imgQuestion6,
    answers: [
      {
        name: 'grade_k4_6_a',
        text: '4/16',
      },
      {
        name: 'grade_k4_6_b',
        text: '12/16',
      },
      {
        name: 'grade_k4_6_c',
        text: '8/16',
        correct: true,
      },
      {
        name: 'grade_k4_6_d',
        text: '10/12',
      },
    ],
  },
  {
    name: 'grade_k4_7',
    title: 'Which fractional multiplication operation is NOT correct?',
    topic: 'Fractional Operations',
    answers: [
      {
        name: 'grade_k4_7_a',
        text: '6 × 2/7 = 4 × 3/7',
      },
      {
        name: 'grade_k4_7_b',
        text: '3 × 5/4 = 15/12',
        correct: true,
      },
      {
        name: 'grade_k4_7_c',
        text: '8 × 3/6 = 6 × 4/6',
      },
      {
        name: 'grade_k4_7_d',
        text: '5 × 4/2 = 4 × 5/2',
      },
    ],
  },
  {
    name: 'grade_k4_8',
    title: 'Which fractional division operation is NOT correct?',
    topic: 'Fractional Operations',
    answers: [
      {
        name: 'grade_k4_8_a',
        text: '4 ÷ 3/4 = 4 × 4/3',
      },
      {
        name: 'grade_k4_8_b',
        text: '2/3 ÷ 2/5 = 2/3 × 5/2',
      },
      {
        name: 'grade_k4_8_c',
        text: '6/8 ÷ 2/4 = 6/8 × 4/2',
      },
      {
        name: 'grade_k4_8_d',
        text: '5/8 ÷ 1/6 = 8/5 × 1/6',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_9',
    title: 'Which fraction is equivalent to 0.0085?',
    topic: 'Decimal Fraction',
    answers: [
      {
        name: 'grade_k4_9_a',
        text: '85/100',
      },
      {
        name: 'grade_k4_9_b',
        text: '85/10000',
        correct: true,
      },
      {
        name: 'grade_k4_9_c',
        text: '85/1000',
      },
      {
        name: 'grade_k4_9_d',
        text: '85/10',
      },
    ],
  },
  {
    name: 'grade_k4_10',
    title: 'If Zak runs 3824 meters in one hour, how will you show this distance in kilometers?',
    topic: 'Unit Conversion and Problem Solving',
    answers: [
      {
        name: 'grade_k4_10_a',
        text: '38km, 24m',
      },
      {
        name: 'grade_k4_10_b',
        text: '3km, 80m',
      },
      {
        name: 'grade_k4_10_c',
        text: '3km, 24m',
      },
      {
        name: 'grade_k4_10_d',
        text: '3km, 824m',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_11',
    title: 'If the area of a rectangular garden is 28cm², its length could be:',
    topic: 'Measurement with Multiplication',
    image: imgQuestion11,
    answers: [
      {
        name: 'grade_k4_11_a',
        text: '20cm',
      },
      {
        name: 'grade_k4_11_b',
        text: '4cm',
      },
      {
        name: 'grade_k4_11_c',
        text: '12cm',
      },
      {
        name: 'grade_k4_11_d',
        text: '7cm',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k4_12',
    title: 'The approx. angle of the given plane figure could be:',
    topic: 'Angle Measure and Plane Figure',
    image: imgQuestion12,
    answers: [
      {
        name: 'grade_k4_12_a',
        text: '120⁰',
      },
      {
        name: 'grade_k4_12_b',
        text: '135⁰',
      },
      {
        name: 'grade_k4_12_c',
        text: '60⁰',
        correct: true,
      },
      {
        name: 'grade_k4_12_d',
        text: '90⁰',
      },
    ],
  },
]
